import { IntField, TextField } from '@ff-it/form';
import { Box, Icon } from '@ff-it/ui';
import { AddInline, Inlines, RemoveInline } from 'components';
import { ReactElement } from 'react';
import { required } from 'utilities';
import { ClipBadge } from './ClipBadge';

const EMPTY_USED_CLIP_IDS = new Set<number>();

interface RadioClipsFieldsProps {
  usedClipIds?: ReadonlySet<number>;
}

export function RadioClipsFields({ usedClipIds = EMPTY_USED_CLIP_IDS }: RadioClipsFieldsProps): ReactElement {
  return (
    <Box>
      <Inlines name="radio_clips">
        {({ name, index, value }) => {
          const used = value.id !== undefined && usedClipIds.has(value.id);
          return (
            <Box border="default" borderRadius="sm" display="flex" p="1" mb="1" gap="2" alignItems="center">
              {value.code && <ClipBadge size="lg" clip={value} />}
              <TextField name={`${name}.name`} placeholder="Optional name" className="mb-0 col px-0" />
              <IntField
                name={`${name}.length_seconds`}
                placeholder="Length in seconds"
                className="mb-0 col px-0"
                required
                validate={required}
              />
              {used ? (
                <Box p="1.5" testId="clip-locked" title="Clip is assigned to placements and can't be removed">
                  <Icon icon="lock" />
                </Box>
              ) : (
                <RemoveInline name="radio_clips" index={index} />
              )}
            </Box>
          );
        }}
      </Inlines>
      <AddInline
        name="radio_clips"
        initialValues={{ name: '', length_seconds: null }}
        className="ml-auto"
        testId="add-clip"
      >
        Add clip
      </AddInline>
    </Box>
  );
}
